import React, { useState, useEffect } from 'react';
import { Button, Accordion, Nav } from 'react-bootstrap';
import { api } from '../apiService';
import { useAuth } from '../AuthContext';
import { Text } from 'react-native';
import { TextEditorDialog } from './TextEditorDialog';
import { toast } from 'react-toastify';
import { useCookies } from 'react-cookie';
import { DeleteDialog } from './DeleteDialog';
import { useNavigate } from 'react-router-dom';
import './animate.css'
import cv_svg from '../img/cv_pdf.svg';
import cover_svg from '../img/cover_pdf.svg';
import regen_svg from '../img/regeneration.svg';
import edit_svg from '../img/edit.svg';
import comment_svg from '../img/comment.svg';
import delete_svg from '../img/delete.svg';

const ApplicationPageAccordion = ({apply_id}) => {
  const { user } = useAuth();
  const profile_email = user?.email;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [status, setStatus] = useState('todo');
  const [selectedItem, setSelectedItem] = useState(null);


  const [editorStateCV, setEditorStateCV] = useState({ show: false, text: "", });
  const openEditorCV = (initialText) => { setEditorStateCV({ show: true, text: initialText }); };
  const [editorStateCover, setEditorStateCover] = useState({ show: false, text: "", });
  const openEditorCover = (initialText) => { setEditorStateCover({ show: true, text: initialText }); };
  const [editorStateComment, setEditorStateComment] = useState({ show: false, text: "", });
  const openEditorComment = (initialText) => { setEditorStateComment({ show: true, text: initialText }); };

  const [showDeleteApplication, setShowDeleteApplication] = useState(false);

  const [isSpinningJob, setIsSpinningJob] = useState(false);
  const [isSpinningCV, setIsSpinningCV] = useState(false);
  const [isSpinningCover, setIsSpinningCover] = useState(false);

  const [cookies] = useCookies(['setting']);

  const navigate = useNavigate();

  const apiServer = process.env.REACT_APP_API_SERVER_URL ?? '/api/';

  useEffect(() => {
      loadFullData(apply_id)
    }, [apply_id]);

  // --- Body  ---
  const loadFullData = async (apply_id) => {
    const [data, error] = await api.get(`full_data/?profile_email=${profile_email}&apply_id=${apply_id}`);
    if (data) {
      setSelectedItem(data);
    }
  };

  // -- Change Status
  const handleStatusChange = async (apply_id, event) => {
    const new_status = event.target.value;
    event.preventDefault();
    setIsSubmitting(true);
    const [data, error] = await api.patch(`update_status/?apply_id=${apply_id}&new_status=${new_status}`,);
    if (data) {
      setStatus(new_status);
      selectedItem.status = new_status;
    }
    setIsSubmitting(false);
  };

  // --- Download ---

  const handleDownloadCV = async (apply_id) => {
    const template_name = cookies?.setting?.template_name==='cv-custom' ? profile_email+'-'+cookies?.setting?.custom_template : cookies?.setting?.template_name ?? "cv-template1";
	const is_convert_pdf = cookies?.setting?.is_convert_pdf ?? 'false';
    await handleDownloadURL('cv_download/' + apply_id + '?template_name='+template_name+'&is_convert_pdf='+is_convert_pdf)
  };

  const handleDownloadCoverLetter = async (apply_id) => {
    await handleDownloadURL('cover_download/' + apply_id + '?is_convert_pdf='+cookies?.setting?.is_convert_pdf)
  };

  const handleDownloadURL = async (download_url) => {
    try {
      const [data, error] = await api.getblob(download_url);
      if (data) {
        const url = window.URL.createObjectURL(data.blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', data.filename); // Set filename
        document.body.appendChild(link);
        link.click();
        // 5. Cleanup: remove element and revoke URL
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error(`Error downloading CV: ${error}`);
      toast.error(`Error downloading CV: ${error}`);
    }
  };


  // --- Regenerate CV ---

  const handleRegenerateJobInsights = async (job_id) => {
    console.log("Regenerate Job Insights:", job_id);
    setIsSpinningJob(true);
    const [data, error] = await api.post('regen_job_insights/' + job_id);
    if (data) {
      toast.success(`Regenerate Job Insights Successful!`);
      setSelectedItem({ ...selectedItem, job_detail: data });
    }
    setIsSpinningJob(false);
  };

  // --- Regenerate CV ---

  const handleRegenerateCV = async (apply_id) => {
    console.log("Regenerate CV:", apply_id);
    setIsSpinningCV(true);
    const [data, error] = await api.post('regen_ai_cv/?apply_id=' + apply_id);
    if (data) {
      toast.success(`Regenerate CV Successful!`);
      loadFullData(apply_id)
    }
    setIsSpinningCV(false);
  };

  // --- Regenerate cover letter ---

  const handleRegenerateCoverLetter = async (apply_id) => {
    console.log("Regenerate CoverLetter:", apply_id);
    setIsSpinningCover(true);
    const [data, error] = await api.post('gen_cover_letter/?apply_id=' + apply_id);
    if (data) {
      toast.success("Regenerate CoverLetter Successful!");
      loadFullData(apply_id)
    }
    setIsSpinningCover(false);
  };

  // --- Interactive AI ---

  const handleEditorSaveCV = async () => {
    console.log("Saving CV to DB:", selectedItem.apply_id);
    setIsSubmitting(true);
    const [data, error] = await api.patch('update_ai_gen_cv/' + selectedItem.apply_id, {'text': editorStateCV.text });
    if (data)setSelectedItem({ ...selectedItem, ai_gen_cv: editorStateCV.text });
    setEditorStateCV({ ...editorStateCV, show: false });
    setIsSubmitting(false);
  };

  const handleEditorSaveCover = async () => {
    console.log("Saving Cover to DB:", selectedItem.apply_id);
    setIsSubmitting(true);
    const [data, error] = await api.patch('update_ai_gen_cover/' + selectedItem.apply_id, {'text': editorStateCover.text } );
    if (data) setSelectedItem({ ...selectedItem, ai_gen_cover: editorStateCover.text });
    setEditorStateCover({ ...editorStateCover, show: false });
    setIsSubmitting(false);
  };

  const handleEditorSaveComment = async () => {
    console.log("Saving Comment to DB:", selectedItem.apply_id);
    setIsSubmitting(true);
    const [data, error] = await api.patch('add_comment/' + selectedItem.apply_id,{'text': editorStateComment.text } );
    if (data);
    setEditorStateComment({ ...editorStateComment, show: false });
    setIsSubmitting(false);
  };

  const handleDeleteApplication = async () => {
    console.log("Delete Application:", selectedItem.apply_id);
    const [data, error] = await api.delete('applies/' + selectedItem.apply_id+'?with_job=True' );
    navigate(0);
  };



  return (
    <div className="mx-auto" style={{ maxWidth: "900px" }}>
      <div className="d-flex justify-content-between align-items-end mb-4">
        <div>
          <a href={selectedItem?.link} target="_blank"><h1>{selectedItem?.title}</h1></a>
          <h4 className="text-secondary">{selectedItem?.company}</h4>
          <span>Status: </span>
          <select value={selectedItem?.status} onChange={(e) => handleStatusChange(selectedItem?.apply_id, e)}>
            <option value="ToDo" className="status-ToDo">📌 ToDo</option>
            <option value="Applied" className="status-Applied">📨 Applied</option>
            <option value="Interviewing" className="status-Interviewing">🤝 Interviewing</option>
            <option value="Offer" className="status-Offer">🎉 Offer</option>
            <option value="Rejected" className="status-Rejected">❌ Rejected</option>
            <option value="NoResponse" className="status-NoResponse">🏳 NoResponse</option>
          </select>,&nbsp;
          <span>Source: {selectedItem?.source},&nbsp;</span>
          <span>created_at: {selectedItem?.created_at}</span>
        </div>
        <div className="d-flex gap-2">

          <Button variant="outline-primary" className="p-1" onClick={() => handleDownloadCV(selectedItem?.apply_id)} >
            <img src={cv_svg} height="36px" width="36px" title="Download CV" />
            </Button>
          <Button variant="outline-success" className="p-1" onClick={() => handleDownloadCoverLetter(selectedItem?.apply_id)} >
            <img src={cover_svg} height="36px" width="36px" title="Download Cover Letter"/></Button>
        </div>
      </div>

      {/* --- SECTIONS --- */}
<Accordion defaultActiveKey="section-ji" className="shadow-sm">

  {/* Job Description Section */}
  <Accordion.Item eventKey="section-ji" className="mb-4">
    <Accordion.Header className="bg-white font-weight-bold">
      <div className="d-flex justify-content-between w-100 pe-3">
        <span>Job Extracted Insights</span>
        <div>
          <a variant="link" size="sm" className="p-0 me-2" onClick={() => handleRegenerateJobInsights(selectedItem?.job_id)} >
            <img src={regen_svg} className={isSpinningJob ? 'spin' : ''}  height="32px" width="32px" title="Regenerate Job Insights" /></a>
        </div>
      </div>
    </Accordion.Header>
    <Accordion.Body className="overflow-auto">
      <Text>{JSON.stringify(selectedItem?.job_detail, null, 2)}</Text>
    </Accordion.Body>
  </Accordion.Item>

  <Accordion.Item eventKey="section-jd" className="mb-4">
    <Accordion.Header className="bg-white font-weight-bold">Job Description</Accordion.Header>
    <Accordion.Body className="overflow-auto">
      <Text>{selectedItem?.description}</Text>
    </Accordion.Body>
  </Accordion.Item>

{/* Active CV Version Section */}
  <Accordion.Item eventKey="section-cv" className="mb-4">
    <Accordion.Header className="bg-white font-weight-bold">
      <div className="d-flex justify-content-between w-100 pe-3">
        <span>Active CV Version</span>
        <div>
          <a variant="link" size="sm" className="p-0 me-2" onClick={(e) => { e.stopPropagation(); handleRegenerateCV(selectedItem?.apply_id); }}>
            <img src={regen_svg} className={isSpinningCV ? 'spin' : ''}  height="32px" width="32px" title="Regenerate CV" /></a>
          <a variant="link" size="sm" className="p-0" onClick={(e) => { e.stopPropagation(); openEditorCV(selectedItem?.ai_gen_cv); }}>
            <img src={edit_svg} height="32px" width="32px" title="Edit CV..." /></a>
        </div>
      </div>
    </Accordion.Header>
    <Accordion.Body>
      <div className="p-5 bg-white border text-left text-muted">
        [<Text>{selectedItem?.ai_gen_cv}</Text>]
      </div>
    </Accordion.Body>
  </Accordion.Item>

  <Accordion.Item eventKey="section-cover" className="mb-4">
    <Accordion.Header className="bg-white font-weight-bold">
      <div className="d-flex justify-content-between w-100 pe-3">
        <span>Generated Cover Letter</span>
        <div>
          <a variant="link" size="sm" className="p-0 me-2" onClick={() => handleRegenerateCoverLetter(selectedItem?.apply_id)} >
            <img src={regen_svg} className={isSpinningCover ? 'spin' : ''}  height="32px" width="32px" title="Regenerate Cover" /></a>
          <a variant="link" size="sm" className="p-0" onClick={() => openEditorCover(selectedItem?.ai_gen_cover)} >
            <img src={edit_svg} height="32px" width="32px" title="Edit Cover..." /></a>
        </div>
      </div>
    </Accordion.Header>
    <Accordion.Body>
      <div className="p-5 bg-white border text-left text-muted">
        {"Dear Hiring Manager at {selectedItem?.company}," ? selectedItem?.ai_gen_cover == null || !selectedItem?.ai_gen_cover.startsWith("Dear") : ""}
        <Text>
          {selectedItem?.ai_gen_cover}
        </Text>
      </div>
    </Accordion.Body>
  </Accordion.Item>

  <Accordion.Item eventKey="section-qa" className="mb-4">
    <Accordion.Header className="bg-white font-weight-bold">AI questions History</Accordion.Header>
    <Accordion.Body>
          {(selectedItem?.apply_detail?.questions || [])
            .sort((a, b) => new Date(a.at) - new Date(b.at)) // Usually want oldest at top for chat flow
            .map((msg, i) => (
              <React.Fragment key={i}>
                {/* User Question */}
                <div className="d-flex mb-3 justify-content-end">
                  <div
                    className="p-2 px-3 shadow-sm bg-primary text-white"
                    style={{ maxWidth: '75%', borderRadius: '15px 15px 2px 15px' }}
                  >
                    <div style={{ fontSize: '0.9rem', textAlign: 'right' }}>
                      <Text> {msg.question} </Text>
                    </div>
                  </div>
                </div>

                {/* Bot Answer */}
                <div className="d-flex mb-3 justify-content-start">
                  <div
                    className="p-2 px-3 shadow-sm bg-light border text-dark"
                    style={{ maxWidth: '95%', borderRadius: '15px 15px 15px 2px' }}
                  >
                    <div style={{ fontSize: '0.9rem', textAlign: 'left' }}>
                      <Text> {msg.answer} </Text>
                    </div>
                    <div className="mt-1 opacity-50 text-muted" style={{ fontSize: '0.65rem' }}>
                      {new Date(msg.at).toLocaleString()}
                    </div>
                  </div>
                </div>
              </React.Fragment>
            ))}
    </Accordion.Body>
  </Accordion.Item>


  <Accordion.Item eventKey="section-hist" className="mb-4">
    <Accordion.Header className="bg-white font-weight-bold">
      <div className="d-flex justify-content-between w-100 pe-3">
        <span>Application History</span>
        <div>
          <a variant="link" size="sm" className="p-0" onClick={() => openEditorComment('')} >
            <img src={comment_svg} height="32px" width="32px" title="Add Comment..." /></a>
        </div>
      </div>
    </Accordion.Header>
    <Accordion.Body>
          <ul className="history-list">
            {(selectedItem?.apply_detail?.history || []).sort((a, b) => new Date(b.at) - new Date(a.at)).map((entry, index) => (
              <li key={index} className="mb-2 border-b pb-1">
                (<small className="text-gray-500">{entry.at}</small>)<br/>
                <Text className="font-bold">{entry.log}</Text>
              </li>
            ))}
          </ul>
    </Accordion.Body>
  </Accordion.Item>

</Accordion>


      <TextEditorDialog
        show={editorStateCV.show}
        text={editorStateCV.text}
        onHide={() => setEditorStateCV({ ...editorStateCV, show: false })}
        onChange={(newVal) => setEditorStateCV({ ...editorStateCV, text: newVal })}
        onSave={handleEditorSaveCV}
      />

      <TextEditorDialog
        show={editorStateCover.show}
        text={editorStateCover.text}
        onHide={() => setEditorStateCover({ ...editorStateCover, show: false })}
        onChange={(newVal) => setEditorStateCover({ ...editorStateCover, text: newVal })}
        onSave={handleEditorSaveCover}
      />

      <TextEditorDialog
        show={editorStateComment.show}
        text={editorStateComment.text}
        onHide={() => setEditorStateComment({ ...editorStateComment, show: false })}
        onChange={(newVal) => setEditorStateComment({ ...editorStateComment, text: newVal })}
        onSave={handleEditorSaveComment}
      />

      <DeleteDialog show={showDeleteApplication} onConfirm={ handleDeleteApplication } />

      <Button variant="secondary" onClick={() => setShowDeleteApplication(!showDeleteApplication) } >
        <img src={delete_svg} className={false ? 'spin' : ''}  height="32px" width="32px" title="" />&nbsp;
        Delete
        </Button>

    </div>
  );
}
export default ApplicationPageAccordion;